import { motion } from "framer-motion";
import EntranceAnimationWithLazyLoad from "../../components/EntranceAnimationWithLazyLoad";
import Footer from "../../components/Footer/Footer";
import NewsLetter from "../../components/Newsletter/NewsLetter";
import Services from "./Services/Services";
import Testimonial from "./Testimonial/Testimonial";
import AmazingFeatures from "./Features/AmazingFeatures";
import HeroComponent from "./Hero/HeroComponent";
import MarketingComponent from "./Marketing/MarketingComponent";
import PaymentMethod from "./Payment/PaymentMethod";
import RecieveMoney from "./Recieve/RecieveMoney";
import ValuesandPrinciples from "./ValuesPrinciples/ValuesandPrinciples";
import EntranceAnimationY from "../../components/EntranceAnimationY";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";

const BusinessPage = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const sections = [
    Services,
    RecieveMoney,
    AmazingFeatures,
    PaymentMethod,
    ValuesandPrinciples,
    Testimonial,
    NewsLetter,
    Footer,
  ];
  return (
    <>
      <HeroComponent />

      <EntranceAnimationY duration={1.5} delay={1}>
        <MarketingComponent />
      </EntranceAnimationY>

      {sections.map((Component, index) => (
        <EntranceAnimationWithLazyLoad key={index}>
          <Component
            newsLetterText={`${t("businessPageNewsLetter.firstLine", { lng: currentLocale })}
                   ${t("businessPageNewsLetter.secondLine", { lng: currentLocale })}
                   ${t("businessPageNewsLetter.thirdLine", { lng: currentLocale })}`}
          />
        </EntranceAnimationWithLazyLoad>
      ))}
    </>
  );
};

export default BusinessPage;
